module.exports = __webpack_public_path__ + "static/media/Caishen2.bf0d4c42.png";